module.exports = __webpack_public_path__ + "static/media/norte2020.7fbfb5f0.webp";